import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "pp-draw-results__inner-wrapper",
  ref: "draw-results-wrapper"
}
const _hoisted_2 = {
  class: "pp-draw-results-button__collapsible-content",
  role: "region",
  id: "pp-draw-results-extra-win-content",
  "aria-labelledby": "pp-draw-results-extra-win"
}
const _hoisted_3 = { class: "pp-draw-numbers__num-row pp-draw-numbers__num-row--extra" }

import { type Component, computed, onMounted, useTemplateRef } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import PpEurojackpotWinnings from "@/lotteries/product-page/components/results/pp-eurojackpot-winnings.vue";
import PpSportkaWinnings from "@/lotteries/product-page/components/results/pp-sportka-winnings.vue";
import PpKenoWinnings from "@/lotteries/product-page/components/results/pp-keno-winnings.vue";
import PpStastnych10Winnings from "@/lotteries/product-page/components/results/pp-s10-winnings.vue";
import { useLotteryResults } from "@/lotteries/services/draw-info/pp-results";
import { LotteryUtils } from "@sazka/lotteries/js/utils/lottery-utils";
import PpDrawNumbersAccordion from "./pp-draw-numbers-accordion.vue";
import { useAccordion } from "@sazka/utils/composables/use-accordion";
import PpKasickaWinnings from "./pp-kasicka-winnings.vue";
import PpMiniRentaWinnings from "./pp-mini-renta-winnings.vue";
import PpEuromilionyWinnings from "./pp-euromiliony-winnings.vue";
import PpExtraRentaWinnings from "./pp-extra-renta-winnings.vue";
import { UrlUtils } from "@sazka/utils/url";
import PpKamenyWinnings from "./pp-kameny-winnings.vue";
import PpRychla6Winnings from "./pp-rychla-6-winnings.vue";
import PpStastneDatumWinnings from "./pp-stastne-datum-winnings.vue";

type VideoList = (typeof videoLists)[keyof typeof videoLists];


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-draw-results-buttons',
  props: {
    lottery: {}
  },
  setup(__props: any) {

const { results } = useLotteryResults();
const wrapper = useTemplateRef("draw-results-wrapper");
const { init } = useAccordion({
    headerClassName: "pp-draw-results-button__collapsible-btn",
    bodyClassName: "pp-draw-results-button__collapsible-content",
});

const props = __props;

const resultsButton = useTemplateRef("resultsButton");

const configureStateFromUrl = () => {
    if (!resultsButton.value) return;

    const url = window.location.search;
    const urlParams = new URLSearchParams(url);

    const resultsParam = urlParams.get("results");

    if (resultsParam === "true") {
        resultsButton.value.$el.classList.add("is-open");
        resultsButton.value.$el.scrollIntoView({ behavior: "smooth" });
    }

    UrlUtils.clearUrlParam("results");
};

onMounted(() => {
    if (!wrapper.value) {
        return;
    }

    configureStateFromUrl();
    const items = wrapper.value.querySelectorAll("[data-accordion]");

    init(items);
});

const videoLists = {
    [Lottery.sportka]: "PL20598F1F704CC8AA",
    [Lottery.eurojackpot]: "PLYgWSC09bLw4jb1l9K_jcb6C4YLV-9rd8",
    [Lottery.euromiliony]: "PL40459FB6DC557B8F",
} as const;

const winnigTableTitle = computed(() => {
    switch (props.lottery) {
        case Lottery.keno:
        case Lottery.stastnych10:
        case Lottery.kasicka:
        case Lottery.kameny:
        case Lottery.rychla6:
        case Lottery.stastneDatum:
            return "Kolik můžu vyhrát?";
        default:
            return "Tabulka výher";
    }
});

const videoListId: VideoList = videoLists[props.lottery];

const getDrawComponent = (lottery: Lottery): Component => {
    switch (lottery) {
        case Lottery.eurojackpot:
            return PpEurojackpotWinnings;
        case Lottery.sportka:
            return PpSportkaWinnings;
        case Lottery.keno:
            return PpKenoWinnings;
        case Lottery.stastnych10:
            return PpStastnych10Winnings;
        case Lottery.kasicka:
            return PpKasickaWinnings;
        case Lottery.miniRenta:
            return PpMiniRentaWinnings;
        case Lottery.euromiliony:
            return PpEuromilionyWinnings;
        case Lottery.extraRenta:
            return PpExtraRentaWinnings;
        case Lottery.kameny:
            return PpKamenyWinnings;
        case Lottery.rychla6:
            return PpRychla6Winnings;
        case Lottery.stastneDatum:
            return PpStastneDatumWinnings;
    }
};
const tableComponent = getDrawComponent(props.lottery);

const downloadLink = computed(() => {
    return `/system/vyherka?year=${results.value?.year}&week=${results.value?.week}&game=${props.lottery}`;
});

const videoLink = computed(() => {
    const url = new URL("https://www.youtube-nocookie.com/embed/");

    url.searchParams.set("list", videoListId);
    url.searchParams.set("autoplay", "true");
    url.searchParams.set("wmode", "transparent");

    return url.toString();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(results))
      ? (_openBlock(), _createBlock(PpDrawNumbersAccordion, {
          key: 0,
          "table-title": winnigTableTitle.value,
          id: "pp-draw-results",
          "aria-controls": "pp-draw-results-content",
          ref_key: "resultsButton",
          ref: resultsButton
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(tableComponent)), {
              class: "pp-draw-results-button__collapsible-content",
              results: _unref(results),
              id: "pp-draw-results-content",
              role: "region",
              "aria-labelledby": "pp-draw-results"
            }, null, 8, ["results"]))
          ]),
          _: 1
        }, 8, ["table-title"]))
      : _createCommentVNode("", true),
    (_unref(results).extraWins)
      ? (_openBlock(), _createBlock(PpDrawNumbersAccordion, {
          key: 1,
          "table-title": "Extra výhra",
          "aria-controls": "pp-draw-results-extra-win-content",
          id: "pp-draw-results-extra-win"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(results).extraWins, (num, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "pp-draw-numbers__number",
                    key: index
                  }, _toDisplayString(num), 1))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(results) && !_unref(LotteryUtils).isQuickLottery(_ctx.lottery))
      ? (_openBlock(), _createBlock(DsButton, {
          key: 2,
          "is-external": true,
          href: downloadLink.value,
          type: "text",
          "icon-right": "arrow-right",
          size: "sm",
          class: "pp-draw-results-button__collapsible-btn--inset pp-draw-results-button"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Stáhnout výherní listinu ")
          ])),
          _: 1,
          __: [0]
        }, 8, ["href"]))
      : _createCommentVNode("", true),
    (_unref(LotteryUtils).isQuickLottery(_ctx.lottery))
      ? (_openBlock(), _createBlock(DsButton, {
          key: 3,
          href: _unref(LotteryUtils).resultsPageUrl(_ctx.lottery),
          type: "text",
          "icon-right": "arrow-right",
          class: "pp-draw-results-button__collapsible-btn--inset pp-draw-results-button",
          size: "sm"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Zobrazit starší výsledky ")
          ])),
          _: 1,
          __: [1]
        }, 8, ["href"]))
      : _createCommentVNode("", true),
    (_unref(videoListId))
      ? (_openBlock(), _createBlock(DsButton, {
          key: 4,
          href: videoLink.value,
          type: "text",
          "icon-right": "arrow-right",
          class: "pp-draw-results-button__collapsible-btn--inset btn-video pp-draw-results-button",
          size: "sm"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Video ze slosování ")
          ])),
          _: 1,
          __: [2]
        }, 8, ["href"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})